module.exports = __webpack_public_path__ + "img/golf-flag-hole.fb7e2a1a.svg";